export default __webpack_public_path__ + "static/media/wc-2022.561d041a.jpg";